export default __webpack_public_path__ + "static/media/legal.ba11e171.svg";